var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparkLogo = function SvgSparkLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1067,
    height: 335,
    viewBox: "0 0 1067 335",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_80)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.375 250.882C338.749 247.686 330.283 243.331 324 237.944L333.497 216.519C339.559 221.34 346.993 225.227 355.901 228.327C364.712 231.425 373.62 232.901 382.528 232.901C393.496 232.901 401.741 231.18 407.215 227.637C412.687 224.096 415.337 219.397 415.337 213.665C415.337 209.435 413.84 205.868 410.772 203.113C407.68 200.358 403.925 198.193 399.239 196.595C394.552 194.996 388.269 193.275 380.147 191.331C368.835 188.699 359.681 185.944 352.712 183.312C345.743 180.68 339.681 176.449 334.651 170.717C329.62 164.987 327.117 157.189 327.117 147.448C327.117 139.208 329.276 131.755 333.743 124.991C338.209 118.225 344.933 112.961 353.865 108.952C362.896 104.943 373.865 103 386.773 103C395.804 103 404.711 104.156 413.521 106.443C422.331 108.731 429.864 111.953 436.147 116.184L427.46 137.609C420.956 133.821 414.208 130.844 407.116 128.901C400.024 126.957 393.177 125.925 386.552 125.925C375.705 125.925 367.583 127.769 362.331 131.435C357.08 135.1 354.332 140.02 354.332 146.095C354.332 150.327 355.828 153.769 358.896 156.525C361.963 159.28 365.743 161.345 370.429 162.945C375.116 164.544 381.399 166.265 389.521 168.209C400.491 170.717 409.644 173.375 416.613 176.228C423.705 178.982 429.767 183.213 434.797 188.821C439.828 194.431 442.331 202.105 442.331 211.747C442.331 219.988 440.171 227.441 435.705 234.082C431.239 240.724 424.515 245.988 415.484 249.997C406.453 254.007 395.361 255.949 382.453 255.949C371.141 255.827 360.172 254.105 349.424 250.907L349.375 250.882Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M561.643 179.72C567.827 174.555 571.016 167.348 571.016 157.828C571.016 148.309 567.924 140.979 561.643 135.936C555.459 130.771 546.329 128.261 534.329 128.261H502.084V187.272H534.329C546.329 187.272 555.483 184.763 561.643 179.72ZM569.176 111.215C578.673 115.447 585.985 121.521 591.115 129.541C596.268 137.436 598.771 146.833 598.771 157.828C598.771 168.824 596.268 177.999 591.115 186.017C585.961 194.036 578.771 200.112 569.176 204.343C559.679 208.575 548.489 210.763 535.581 210.763H502.084V253.736H474.527V104.893H535.557C548.367 104.893 559.556 106.96 569.152 111.191L569.176 111.215Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M701.42 197.48L673.42 132.395L645.641 197.48H701.42ZM710.573 219.249H636.391L621.764 253.613H593.299L660.047 104.893H687.139L754.132 253.613H725.321L710.573 219.249Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M861.346 135.936C855.162 130.771 846.032 128.261 834.032 128.261H801.788V187.493H834.032C846.032 187.493 855.186 184.861 861.346 179.696C867.504 174.531 870.719 167.2 870.719 157.705C870.719 148.309 867.627 140.979 861.346 135.936ZM871.284 253.613L841.002 210.075C839.751 210.197 837.812 210.296 835.284 210.296H801.788V253.613H774.229V104.893H835.26C848.069 104.893 859.381 107.059 868.855 111.313C878.351 115.544 885.664 121.62 890.793 129.639C895.947 137.535 898.449 146.932 898.449 157.927C898.449 168.923 895.7 178.786 890.327 186.805C884.829 194.824 877.075 200.9 866.891 204.909L901.075 253.835H871.235V253.613H871.284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M982.596 191.404L959.037 215.584V253.613H931.48V104.893H959.037V181.196L1032.41 104.893H1063.38L1001.07 171.357L1067.26 253.613H1035.01L982.547 191.404H982.596Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 195,
    width: 120,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.602 333.627L0.738019 200.847C-1.3974 198.363 1.49844 194.771 4.36978 196.345L80.9333 237.99C84.5407 239.957 87.338 243.18 88.7615 247.043L119.583 330.674C120.712 333.749 116.736 336.112 114.602 333.627Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.602 333.627L0.738019 200.847C-1.3974 198.363 1.49844 194.771 4.36978 196.345L80.9333 237.99C84.5407 239.957 87.338 243.18 88.7615 247.043L119.583 330.674C120.712 333.749 116.736 336.112 114.602 333.627Z",
    fill: "url(#paint0_linear_2_80)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 53,
    width: 61,
    height: 252
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.043 303.102L99.6322 147.445C99.1661 145.132 99.6322 142.697 100.884 140.705L155.705 54.7107C156.809 52.988 159.485 53.8987 159.288 55.9653L134.896 302.904C134.675 305.143 131.485 305.291 131.043 303.102Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.043 303.102L99.6322 147.445C99.1661 145.132 99.6322 142.697 100.884 140.705L155.705 54.7107C156.809 52.988 159.485 53.8987 159.288 55.9653L134.896 302.904C134.675 305.143 131.485 305.291 131.043 303.102Z",
    fill: "url(#paint1_linear_2_80)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 165,
    width: 112,
    height: 96
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.233 257.251L218.503 169.361C220.564 166.36 224.147 164.811 227.755 165.352L266.305 171.207C268.784 171.576 269.619 174.748 267.656 176.299L161.252 260.104C159.363 261.58 156.884 259.243 158.233 257.275V257.251Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.233 257.251L218.503 169.361C220.564 166.36 224.147 164.811 227.755 165.352L266.305 171.207C268.784 171.576 269.619 174.748 267.656 176.299L161.252 260.104C159.363 261.58 156.884 259.243 158.233 257.275V257.251Z",
    fill: "url(#paint2_linear_2_80)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 0,
    width: 63,
    height: 200
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.239 196.985L198.061 1.65199C198.38 -0.364008 201.177 -0.610661 201.84 1.33334L229.177 81.128C229.987 83.5147 229.791 86.1213 228.613 88.36L170.896 198.215C169.865 200.159 166.896 199.175 167.239 197.009V196.985Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.239 196.985L198.061 1.65199C198.38 -0.364008 201.177 -0.610661 201.84 1.33334L229.177 81.128C229.987 83.5147 229.791 86.1213 228.613 88.36L170.896 198.215C169.865 200.159 166.896 199.175 167.239 197.009V196.985Z",
    fill: "url(#paint3_linear_2_80)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 107,
    width: 54,
    height: 105
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1178 158.44L42.0136 109.367C42.3079 107.349 45.0563 106.981 45.8662 108.851L88.3932 208.202C89.2522 210.219 86.749 211.965 85.1542 210.465L37.6948 165.82C35.6823 163.925 34.7006 161.145 35.0932 158.416L35.1178 158.44Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1178 158.44L42.0136 109.367C42.3079 107.349 45.0563 106.981 45.8662 108.851L88.3932 208.202C89.2522 210.219 86.749 211.965 85.1542 210.465L37.6948 165.82C35.6823 163.925 34.7006 161.145 35.0932 158.416L35.1178 158.44Z",
    fill: "url(#paint4_linear_2_80)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_80",
    x1: -5.14396,
    y1: -490.001,
    x2: 73.1987,
    y2: 419.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_80",
    x1: 128.407,
    y1: -104.196,
    x2: 130.597,
    y2: 358.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_80",
    x1: 183.699,
    y1: -438.789,
    x2: 222.292,
    y2: 415.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_80",
    x1: 196.957,
    y1: -13.6813,
    x2: 202.515,
    y2: 565.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_80",
    x1: 2.41155,
    y1: 55.6214,
    x2: 136.194,
    y2: 335.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1066.67,
    height: 334.667,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spark-logo.33c4de97162aea57bb1849f502052ee6.svg";